// extracted by mini-css-extract-plugin
export default {"container":"metric_table_container__ym2KO","row":"metric_table_row__N41RQ","label":"metric_table_label__vHOUO","value":"metric_table_value__doxAq"};